export const BILLING_REFRESH_EVENT = 'billing-refresh';

export const triggerBillingRefresh = () => {
  window.dispatchEvent(new CustomEvent(BILLING_REFRESH_EVENT));
};

export const subscribeBillingRefresh = (callback: () => void) => {
  window.addEventListener(BILLING_REFRESH_EVENT, callback);
  return () => window.removeEventListener(BILLING_REFRESH_EVENT, callback);
};